import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../../lib/api";
import { errText } from "../biz/i18n";
import { Card, Empty, inp } from "../biz/ui";
import { useLabT } from "./i18n";
import { ReceiptButtons } from "../ReceiptButtons";

const NEXT = ["paid", "preparing", "shipped", "delivered", "cancelled"];

export function LabOrders() {
  const { t, aed } = useLabT();
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api.get("/admin/lab/orders").then((r) => setRows(r.data)).catch((e) => toast.error(errText(e))), []);
  useEffect(() => { load(); }, [load]);
  const setStatus = async (o, status) => {
    try { await api.put(`/admin/lab/orders/${o.order_number}/status`, { status }); toast.success(t("saved")); load(); } catch (e) { toast.error(errText(e)); }
  };
  if (!rows) return null;
  if (!rows.length) return <Empty>{t("no_items")}</Empty>;
  return (
    <div className="space-y-3">
      {rows.map((o) => (
        <Card key={o.id} testid={`lab-order-${o.order_number}`}>
          <div className="flex items-center justify-between gap-3 flex-wrap">
            <div><b dir="ltr">{o.order_number}</b> <span className="text-xs text-[#8A8173]" dir="ltr">· {o.release_code} · {o.created_at?.slice(0, 10)}</span></div>
            {o.payment_status === "paid"
              ? <select value={o.status} onChange={(e) => setStatus(o, e.target.value)} data-testid={`lab-order-status-${o.order_number}`} className={`${inp} !w-auto !py-2`}>
                  {NEXT.map((s) => <option key={s} value={s}>{t(`s_${s}`)}</option>)}</select>
              : <span className="text-xs rounded-full px-2.5 py-1 bg-[#EFEAE2] text-[#6B645A]">{o.status === "pending_payment" ? t("pending") : t(`s_${o.status}`)}</span>}
          </div>
          <p className="text-sm mt-2" dir="ltr">{o.customer?.full_name} · {o.email} · {o.customer?.phone}</p>
          <p className="text-xs text-[#8A8173]">{o.customer?.city}, {o.customer?.country} — {o.customer?.address}</p>
          <p className="text-xs text-[#6B645A] mt-2" dir="ltr">{o.items.map((i) => `${i.code} ×${i.qty}`).join(" · ")} {o.mode === "set" ? `(${o.sets} set)` : ""}</p>
          <div className="mt-3"><ReceiptButtons number={o.order_number} light /></div>
          <p className="text-sm font-semibold mt-1">{t("total")}: <span dir="ltr">{aed(o.total)}</span> </p>
        </Card>
      ))}
    </div>
  );
}
